import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { App } from "./App";
import { removeLegacyServiceWorker } from "./lib/sw-cleanup";

// The Next.js app installed a service worker; the SPA that replaced it
// registers none, so the old one is still live in every returning
// browser with a cache-first catch-all and no way to update itself.
// Clear it before anything else. See lib/sw-cleanup.ts.
removeLegacyServiceWorker();

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
